export const enumDeploymentRequestStatus = {
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PAUSED: 'PAUSED',
  PROCESSING: 'PROCESSING',
  RUNNING: 'RUNNING',
  SCHEDULED: 'SCHEDULED',
} as const;
export type EnumDeploymentRequestStatus =
  (typeof enumDeploymentRequestStatus)[keyof typeof enumDeploymentRequestStatus];

export const enumReferenceMode = {
  CUSTOM: 'CUSTOM',
  ID: 'ID',
} as const;
export type EnumReferenceMode = (typeof enumReferenceMode)[keyof typeof enumReferenceMode];

export const enumDeploymentRequestTrigger = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
  SCHEDULED: 'SCHEDULED',
} as const;
export type EnumDeploymentRequestTrigger =
  (typeof enumDeploymentRequestTrigger)[keyof typeof enumDeploymentRequestTrigger];

export const enumConfigurationResourceSoftwareItem = {
  CONFIGURATION_MODULE: 'CONFIGURATION_MODULE',
  SOFTWARE_VERSION_NO_PARAM: 'SOFTWARE_VERSION_NO_PARAM',
} as const;
export type EnumConfigurationResourceSoftwareItem =
  (typeof enumConfigurationResourceSoftwareItem)[keyof typeof enumConfigurationResourceSoftwareItem];

export const enumCreatorType = {
  AUTOMATOR: 'AUTOMATOR',
  USER: 'USER',
} as const;
export type EnumCreatorType = (typeof enumCreatorType)[keyof typeof enumCreatorType];

export declare const enumAssetType: {
  readonly IMAGE: 'IMAGE';
  readonly LOGO: 'LOGO';
  readonly VIDEO: 'VIDEO';
};
export type EnumAssetType = (typeof enumAssetType)[keyof typeof enumAssetType];

export declare const enumDeploymentAutomatorStatus: {
  readonly DISABLED: 'DISABLED';
  readonly ENABLE: 'ENABLE';
};
export type EnumDeploymentAutomatorStatus =
  (typeof enumDeploymentAutomatorStatus)[keyof typeof enumDeploymentAutomatorStatus];

export declare const enumDeploymentAutomatorTriggerType: {
  readonly MANUAL: 'MANUAL';
  readonly ON_CONFIGURATION_CHANGE: 'ON_CONFIGURATION_CHANGE';
  readonly ON_SMART_FIELD_CHANGE: 'ON_SMART_FIELD_CHANGE';
  readonly ON_SMART_GROUP_CHANGE: 'ON_SMART_GROUP_CHANGE';
};
export type EnumDeploymentAutomatorTriggerType =
  (typeof enumDeploymentAutomatorTriggerType)[keyof typeof enumDeploymentAutomatorTriggerType];

export declare const enumDeploymentActionType: {
  readonly CANCEL: 'CANCEL';
  readonly PAUSE: 'PAUSE';
  readonly RESUME: 'RESUME';
  readonly RETRY: 'RETRY';
};
export type EnumDeploymentActionTypeV2 = (typeof enumDeploymentActionType)[keyof typeof enumDeploymentActionType];
